import { render, staticRenderFns } from "./bidding06.vue?vue&type=template&id=0ceacfa9&scoped=true&"
import script from "./bidding06.vue?vue&type=script&lang=js&"
export * from "./bidding06.vue?vue&type=script&lang=js&"
import style0 from "./bidding06.vue?vue&type=style&index=0&id=0ceacfa9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceacfa9",
  null
  
)

export default component.exports